import {Component, OnInit, Input} from '@angular/core';
import moment from 'moment';
import {TranslateService} from "@ngx-translate/core";
import localeHe from '@angular/common/locales/he';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeHe);

@Component({
    selector: 'date-format',
    templateUrl: './date-format.component.html',
    styleUrls: ['./date-format.component.scss'],
    standalone: false
})
export class DateFormatComponent implements OnInit {
    @Input() source;
    @Input() fromFormat;
    @Input() toFormat = 'short';
    @Input() timezone = '';
    date;

    constructor( public translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.date = moment(this.source, this.fromFormat);
        /* In case valid return date, invalid case of : " ", undefined return null. */
        /* Use Moment's isValid function */
        this.date = (this.date.isValid()) ? this.date : null;
    }
}
